import ContactUs from "../../components/ContactUs";
import StayInLoop from "../../components/StayInLoop";
import AchieveOutcome from "../../components/AchieveOutcome/AchieveOutcome";
import WeAreIED from "../../components/WeAreIED";
import AnimatedCardCrausal from "../../components/AnimatedCardCrausal";
import IndustriesFeaturelistSection from "../../components/IndustriesFeatureListSection";
import { BackGroundPowerVideo, PowerVideo, OverlayImg1 ,
    AssetReliability,
  BusinessOutcomes,
  ConnectedWorkforce,
  DigitalEnablers,
  EnergyPriorities,
  GenerationIntelligence,
  GridNetworkOperations,
  RiskCompliance,
  SustainabilityCarbon,
} from "../../constant";
import ThreeLongCard from "../../components/IndustriesThreeLongCard";
import ParaVideoSection from "../../components/IndustriesParaVideoSection";
import PowerAndRenewableLanding from "../../components/Industries/PowerAndRenewableLanding";

const AnimatedCardCrausalData = [
    {
         icon:ConnectedWorkforce,
        title: "Connected Workforce",
        description:
            "Empowering Field Teams",
        data: "Improve workforce safety, permit management, contractor oversight, and field operations across generation, transmission, and renewable energy assets."
    },
    {
        icon:AssetReliability,
        title: "Asset Reliability",
        description:
            "Maximizing Infrastructure Performance.",
        data: "Monitor equipment health, maintenance activities, asset condition, and operational availability to reduce downtime and improve reliability."
    },
    {
         icon:GenerationIntelligence,
        title: "Generation Intelligence",
        description: "Enhancing Energy Production",
        data: "Track generation performance, plant efficiency, operational KPIs, and resource utilization across conventional and renewable energy facilities."
    },
    {
         icon:GridNetworkOperations,
        title: "Grid & Network Operations",
        description: "Strengthening System Resilience",
        data: "Gain greater control over transmission networks, substations, distribution assets, and critical infrastructure through real-time operational monitoring."
    },
    {
         icon:SustainabilityCarbon,
        title: "Sustainability & Carbon",
        description: "Supporting Net Zero Goals",
        data: "Measure emissions, renewable energy performance, environmental commitments, and sustainability initiatives through a centralized platform."
    },
    {
         icon:RiskCompliance,
        title: "Risk & Compliance",
        description: "Ensuring Regulatory Readiness",
        data: "Manage inspections, audits, incidents, corrective actions, and compliance obligations while maintaining governance across energy operations."
    },

];

const longCardData = [
    {
        title: "Energy Priorities",
        icon:EnergyPriorities,
        listItems: [
            "Grid Reliability",
            "Workforce Safety",
            "Environmental Stewardship",
            "Asset Availability",
            "Regulatory Compliance",
        ]
    },
    {
        title: "Digital Enablers",
        icon:DigitalEnablers,
        listItems: [
            "Connected Assets",
            "Industrial IoT",
            "Advanced Analytics",
            "Artificial Intelligence",
            "Enterprise Integration",
        ]
    },
    {
        title: "Business Outcomes",
        icon:BusinessOutcomes,
        listItems: [
            "Higher Asset Utilization",
            "Reduced Unplanned Downtime",
            "Faster Issue Resolution",
            "Improved Resource Efficiency",
            "Stronger Operational Control",
        ]
    }
];

const leftSecionData = {
    title: "Built for a Rapidly Evolving Energy Landscape",
    para: ["From thermal plants and transmission networks to solar parks and wind farms, energy organizations require greater control over critical assets, field activities, environmental programs, and enterprise-wide processes. iEnergy brings together operational data, workforce activities, asset information, and sustainability initiatives into a unified platform that supports informed decision-making and stronger organizational oversight. By connecting business priorities with day-to-day execution, organizations can improve reliability, enhance resource utilization, and maintain compliance while advancing long-term energy objectives. "
    ],
    mediaUrl: PowerVideo,
    imgeUrl: OverlayImg1,
}


const featurelist = {
    listTitle: "Building Resilient Energy Enterprises",
    listSubTitle: "As the energy sector evolves, organizations need stronger coordination across assets, people, infrastructure, and sustainability commitments. From generation and transmission to renewable portfolios, empowering smarter execution across the energy value chain.",
    listItems: [
  "Improve asset utilization through proactive maintenance, condition monitoring, and lifecycle management.",
  "Strengthen grid and plant reliability with real-time operational oversight and faster issue resolution.",
  "Advance environmental and sustainability objectives through integrated ESG, emissions, and compliance management.",
  "Enhance workforce and contractor governance across field operations, maintenance activities, and critical infrastructure projects.",
  "Enable data-driven planning and enterprise-wide visibility across generation, transmission, distribution, and renewable energy assets.",
],
}





export default function PowerAndRenewablePage() {
    return (
        <>
            <PowerAndRenewableLanding />
            <AnimatedCardCrausal
                title={"Powering the Energy Systems of Tomorrow"}
                subTitle={"Utilities and renewable energy operators are navigating growing demands around reliability, environmental responsibility, workforce safety, and infrastructure modernization. iEnergy helps organizations strengthen asset stewardship, streamline field operations, and support long-term energy goals across generation, transmission, and renewable portfolios."}
                data={AnimatedCardCrausalData}
            />

            <ParaVideoSection
                title={"Enabling Reliable and Responsible Energy Operations."}
                subTitle={"Power and renewable energy organizations are balancing growing demand, aging infrastructure, environmental commitments, and evolving regulatory expectations."}
                data={leftSecionData}
            />
            <ThreeLongCard
                title={"Unlock Value with Cutting-Edge Technology"}
                subTitle={"Leverage advanced analytics, AI-driven insights, and automation to drive operational efficiency and sustainability."}
                data={longCardData}
            />
            <IndustriesFeaturelistSection data={featurelist} backgroundItem={BackGroundPowerVideo} />
            <AchieveOutcome
                title={`Advancing Modern Power & Renewable Operations`}
                subTitle={`From conventional generation and transmission networks to solar and wind portfolios, IENERGY helps organizations manage assets, workforce activities, environmental programs, and compliance obligations through a unified enterprise platform.`}
            />

            <WeAreIED />
            <ContactUs />
            <StayInLoop />
        </>
    );
}
